const isPerformanceSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.PerformanceSection => {
  return s.sectionType === 'Performance Graph';
};

export default isPerformanceSection;
